import { useContext, useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import close from "../assets/close.png";
import _close from "../assets/close-white.png";
import logo from "../assets/logo.png";
import sidebar from "../assets/sidebar.png";
import _sidebar from "../assets/sidebar-white.png";
import Button from "../components/Button.js";
import { ThemeContext } from "../ThemeContext.js";
import ActiveLink from "../utilities/ActiveLink.js";

const Header = ({ width }) => {
  const items = ["home", "gallery", "about", "contact"];
  const [active, setActive] = useState(false);
  const { theme, toggleTheme } = useContext(ThemeContext);

  const [isSwiping, setIsSwiping] = useState(false);
  const [offsetX, setOffsetX] = useState(0);
  const touchStartX = useRef(0);
  const navRef = useRef(null);

  // 🔥 Ripple attraction effect state
  const [rippleActive, setRippleActive] = useState(true);
  const [showRipple, setShowRipple] = useState(false);

  // Auto ripple animation every few seconds (until user clicks)
  useEffect(() => {
    if (!rippleActive) return;
    const interval = setInterval(() => {
      setShowRipple(true);
      setTimeout(() => setShowRipple(false), 1200);
    }, 4000);
    return () => clearInterval(interval);
  }, [rippleActive]);

  const onTouchStart = (e) => {
    if (active) {
      setIsSwiping(true);
      touchStartX.current = e.targetTouches[0].clientX;
    }
  };

  const onTouchMove = (e) => {
    if (isSwiping) {
      const currentX = e.targetTouches[0].clientX;
      const deltaX = currentX - touchStartX.current;
      if (deltaX > 0) {
        setOffsetX(deltaX);
      }
    }
  };

  const onTouchEnd = () => {
    if (isSwiping) {
      setIsSwiping(false);
      const screenWidth = navRef.current
        ? navRef.current.offsetWidth
        : window.innerWidth;
      if (offsetX > screenWidth / 3) {
        setActive(false);
      }
      setOffsetX(0);
    }
  };

  const getLeftPosition = () => {
    if (!active) return "125%";
    if (isSwiping) return `${offsetX}px`;
    return "0";
  };

  const handleThemeToggle = (event) => {
    // Disable automatic ripple forever after first click
    setRippleActive(false);
    setShowRipple(false);

    // Click ripple animation
    const button = event.currentTarget;
    const circle = document.createElement("span");
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;

    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${
      event.clientX - button.getBoundingClientRect().left - radius
    }px`;
    circle.style.top = `${
      event.clientY - button.getBoundingClientRect().top - radius
    }px`;
    circle.classList.add("ripple");

    const ripple = button.getElementsByClassName("ripple")[0];
    if (ripple) ripple.remove();
    button.appendChild(circle);

    toggleTheme();
  };

  return (
    <header id="back-to-top-anchor" className="header">
      {width === "xs" ? (
        <>
          <div
            className={`logo-container ripple-container ${
              showRipple ? "logo-pulse" : ""
            }`}
            onClick={handleThemeToggle}
          >
            <img alt="logo" className="header-logo" src={logo} />
          </div>

          <p className="header-title">
            <Link to="/">
              DEMETRIOUS MIZZAWI<sup>©</sup>
            </Link>
          </p>

          <Button
            onClick={() => setActive(true)}
            className="sidebar-menu-button"
          >
            <img
              alt="menu"
              className="sidebar-menu-img"
              src={theme === "dark" ? _sidebar : sidebar}
            />
          </Button>
          <div
            ref={navRef}
            style={{ left: getLeftPosition() }}
            className={`header-nav ${isSwiping ? "is-swiping" : ""}`}
            onClick={(e) => {
              if (e.target.classList.contains("header-nav")) setActive(false);
            }}
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
          >
            <div className="sidebar-header">
              <Button
                className="sidebar-close-button"
                onClick={() => setActive(false)}
              >
                <img
                  alt="close"
                  className="sidebar-close-img"
                  src={theme === "dark" ? _close : close}
                />
              </Button>
            </div>
            <ul className="nav-list">
              {items.map((item) => (
                <li className="nav-item" key={item}>
                  <ActiveLink
                    to={item === "home" ? "/" : "/" + item}
                    onLinkClick={() => setActive(false)} // Pass the close function
                  >
                    {item}
                  </ActiveLink>
                </li>
              ))}
            </ul>
          </div>
        </>
      ) : (
        <>
          <div
            className={`logo-container ripple-container ${
              showRipple ? "logo-pulse" : ""
            }`}
            onClick={handleThemeToggle}
          >
            <img alt="logo" className="header-logo" src={logo} />
          </div>
          <p className="header-title">
            <Link to="/">
              DEMETRIOUS MIZZAWI<sup>©</sup>
            </Link>
          </p>
          <div className="header-nav">
            <ul className="nav-list">
              {items.map((item) => (
                <li className="nav-item" key={item}>
                  <ActiveLink to={item === "home" ? "/" : "/" + item}>
                    {item}
                  </ActiveLink>
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </header>
  );
};

export default Header;
